import { Component, OnInit, ViewChild } from "@angular/core";
import { FieldWrapper } from "@ngx-formly/core";
import { testHtmlRegex, showErrorMessage } from "../../helpers/helpers";
import { get as _get } from "lodash-es";

@Component({
  selector: "app-common-wrapper",
  templateUrl: "./common-wrapper.component.html",
  styleUrls: ["./common-wrapper.component.scss"],
})
export class CommonWrapperComponent extends FieldWrapper implements OnInit {
  @ViewChild("form") elementView: any;
  isHtml: boolean = false;
  isMarginRequired: boolean = true;
  isWidthRequired: boolean = true;
  showErrMessage = showErrorMessage;
  widthClass: string = "";

  ngOnInit(): void {
    this.isHtml = testHtmlRegex(this.props.description);
    if (_get(this.field, 'props.maxLength') <= 1000){
      this.widthClass = "w-160-5"
    }else if(_get(this.field, 'props.maxLength') <= 1500){
      this.widthClass = "w-200";
    }
  }

  ngAfterViewInit() {
    if (this.elementView?._elementRef?.nativeElement?.offsetWidth > 800) {
      this.isWidthRequired = true;
    }
  }
}
